import { render, staticRenderFns } from "./ProficiencyBadgeExpired.vue?vue&type=template&id=2023ede8"
import script from "./ProficiencyBadgeExpired.vue?vue&type=script&lang=js"
export * from "./ProficiencyBadgeExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports